module.exports = __webpack_public_path__ + "media/semantic/dist/themes/default/assets/fonts/icons-1ab236ed440ee51810c56bd16628aef0.ttf";